import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({ imageUrl, overlayImageUrl, title, description, onClick, arrowIcon, url }) => {
  const handleClick = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div className="project-card" onClick={handleClick} data-name="Project Card">
      <div className="project-card-image-container">
        <div className="project-card-image" data-name="image">
          <img 
            src={imageUrl} 
            alt={title}
          />
          {overlayImageUrl && (
            <div className="project-card-image-overlay">
              <img 
                src={overlayImageUrl} 
                alt={`${title} mockup`}
              />
            </div>
          )}
        </div>
      </div>
      <div className="project-card-content">
        <div className="project-card-header">
          <h3 className="project-card-title">{title}</h3>
          <div className="project-card-icon" data-name="solar:arrow-right-up-linear">
            <img src={arrowIcon} alt="external link" />
          </div>
        </div>
        <p className="project-card-description">{description}</p>
      </div>
    </div>
  );
};

export default ProjectCard;

